<template>
  <v-menu :disabled="!btnState">
    <template v-slot:activator="{ on }">
      <v-btn
        class="navbarButton initial v-step-0"
        transition="slide-y-transition v-step-0"
        v-on="on"
        :disabled="!btnState"
      >
        <v-icon>file_download</v-icon>
        Template
      </v-btn>
    </template>
    <v-list v-if="btnState">
      <v-list-item @click="download">
        <v-list-item-title>
          <span class="menu-item-title"> Template vide </span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click="last_optimisation_export">
        <v-list-item-title>
          <span class="menu-item-title"> Template rempli </span>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      spinnerShown: false,
      bouttonPrevState: new Array(),
    };
  },
  computed: {
    ...mapGetters({
      btnState: 'btnDownloadValue',
    }),
  },
  methods: {
    download() {
      if (this.btnState === true) {
        const exportTemplateFileUrl =
          process.env.VUE_APP_BASE_URL + process.env.VUE_APP_DOWNLOAD_FILE;
        const user = this.$store.state.user;
        var self = this;
        self.btn = 'btn-disabled';
        axios({
          method: 'get',
          url: exportTemplateFileUrl,
          headers: {
            'Content-Type': 'application/json',
            user: user,
          },
          responseType: 'blob',
        })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Optiflux_Template_import.xlsx');
            document.body.appendChild(link);
            link.click();
          })
          .catch(function (error) {
            self.$toasted.show(
              "Votre fichier n'a pas pu être traité, veuillez nous excuser.",
              { type: 'error' }
            );
          });
      } else {
        /* console.warn(
          "Ce bouton est désactivé pour des raisons de sécurité. Veuillez ne pas forcer l'action."
        ); */
      }
    },
    last_optimisation_export() {
      if (this.btnState === true) {
        const exportTemplateFileUrlLastScript =
          process.env.VUE_APP_BASE_URL + process.env.VUE_APP_LAST_OPTIMISATION;
        const user = this.$store.state.user;
        var self = this;
        const message = 'Export en cours...';
        self.$emit('load-spinner', message);
        self.btn = 'btn-disabled';
        self.$store.commit('getButtonStates', this.bouttonPrevState);
        self.$store.commit('setAllButtonsHidden');
        axios({
          method: 'get',
          url: exportTemplateFileUrlLastScript,
          headers: {
            'Content-Type': 'application/json',
            user: user,
          },
          responseType: 'blob',
        })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Optiflux_Template_import.xlsx');
            document.body.appendChild(link);

            link.click();
          })
          .catch(function (error) {
            self.$toasted.show(
              "Votre fichier n'a pas pu être traité, veuillez nous excuser.",
              { type: 'error' }
            );
          })
          .finally(() => {
            self.$emit('hide-spinner');   
            self.$store.commit(
              'setButtonToPreviousState',
              this.bouttonPrevState
            );
          });
      } else {
        /* console.warn(
          "Ce bouton est désactivé pour des raisons de sécurité. Veuillez ne pas forcer l'action."
        ); */
      }
    },
  },
};
</script>

<style scoped lang="scss" >
@import '@/assets/scss/main.scss';
i.material-icons {
  line-height: 2.18rem;
}

.menu {
  margin-top: 6px;
  max-height: 36px;
}
.menu span {
  color: white;
}
.menu-container {
  align-items: center;
}
.application span {
  cursor: pointer;
  color: white;
  font-variant: all-small-caps;
  font-size: 1.125rem;
}
.theme--light.v-list {
  background: $altGreen;
  color: white;
}
.v-list > div:hover {
  color: white;
  background: $altYellow;
}

.v-list-item__title {
  color: white;
}
</style>
